import React, { useState } from 'react'

import { useProject } from 'hooks'

import { ImsOrgSection } from './partials/ImsOrgSection'
import { ChatBotTile, Tile } from './partials/tiles'

import './IntegrationsForm.scss'

const IntegrationsForm = () => {
  const { project, config, updateProjectPart, canEdit, type } = useProject()
  const [integrations, setIntegrations] = useState(project.integrations || {})

  const { chatBotOptions } = config
  const { chatBot } = integrations

  const updateIntegrations = (updateFunction) => {
    let updatedIntegrations = integrations
    setIntegrations((i) => {
      updatedIntegrations = updateFunction(i)
      updateProjectPart('integrations', updatedIntegrations)
      return updatedIntegrations
    })
  }

  const updateIntegration = (integrationName) => (updateParam) => {
    if (typeof updateParam === 'function') {
      updateIntegrations((i) => ({ ...i, [integrationName]: updateParam(i[integrationName]) }))
    } else {
      updateIntegrations((i) => ({ ...i, [integrationName]: updateParam }))
    }
  }

  return (
    <div className='IntegrationsForm'>
      <section>
        <div className='IntegrationsForm__project'>
          <Tile name='This project' text={project?.id} active={true} />
        </div>
      </section>
      <section>
        <ImsOrgSection
          channel={config?.channel}
          projectName={project?.meta?.title}
          projectType={type}
          integrations={integrations}
          disabled={!canEdit}
          onChange={updateIntegrations}
        />
        <div className='IntegrationsForm__other'>
          {type === 'web-modular' && (
            <ChatBotTile
              chatBot={chatBot}
              chatBotOptions={chatBotOptions}
              disabled={!canEdit}
              onChange={updateIntegration('chatBot')}
            />
          )}
        </div>
      </section>
    </div>
  )
}

export default IntegrationsForm
